import React, { useRef, useEffect } from 'react'; // <--- Tambahkan useRef dan useEffect
import './RekanataContent.css';

// Import video Anda dari folder lokal
// Sesuaikan path ini dengan lokasi video Anda
import MyRenderVideo from '../../../../assets/raw/intro-hero-video.mp4';


const RekanataContent = () => {
  const videoRef = useRef(null); // <--- Buat ref untuk video

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return; // Pastikan elemen video ada

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Video masuk ke viewport, putar
            videoElement.play().catch(error => {
              // Menangani potensi kesalahan jika play() gagal (misalnya, karena aturan browser)
              console.log("Video play failed:", error);
            });
          } else {
            // Video keluar dari viewport, hentikan
            videoElement.pause();
          }
        });
      },
      {
        threshold: 0.5, // Video akan di-play/pause ketika 50% terlihat/tidak terlihat
      }
    );

    observer.observe(videoElement); // Mulai observasi elemen video

    // Fungsi cleanup saat komponen di-unmount
    return () => {
      observer.unobserve(videoElement);
      observer.disconnect();
    };
  }, []); // [] agar efek hanya berjalan sekali setelah render pertama


  return (
    <>
      {/* Bagian Pembuka/Hero Section */}
      <section className="rekanata-hero-section">
        <h1 className="rekanata-main-heading">
          Rekanata Konstruksi - Solusi Bangunan Profesional dan Amanah Anda
        </h1>
        <p className="rekanata-tagline">
          Membangun Impian, Mengukir Kualitas. Kami adalah mitra terpercaya Anda untuk setiap proyek konstruksi di seluruh Indonesia.
        </p>
      </section>

      {/* Bagian Tentang Kami */}
      <section className="rekanata-about-section">
        <h2 className="rekanata-section-heading">Siapa Kami?</h2>
        <p>
          Rekanata Konstruksi adalah perusahaan kontraktor terkemuka dengan rekam jejak yang terbukti dalam menghadirkan solusi konstruksi berkualitas tinggi. Berbasis di Bandung, Jawa Barat, kami bangga melayani berbagai proyek pembangunan dan renovasi di seluruh wilayah Indonesia. Dedikasi kami pada kualitas tak tertandingi, integritas mutlak, dan penyelesaian tepat waktu memastikan setiap proyek tidak hanya memenuhi, tetapi melampaui standar industri dan harapan klien.
        </p>
        <p>
          Nama "Rekanata" bukan sekadar identitas, melainkan cerminan filosofi kami sebagai rekan kerja yang andal dan profesional bagi setiap klien. Kami memahami bahwa setiap proyek konstruksi adalah investasi signifikan, baik secara finansial maupun emosional. Oleh karena itu, kami berkomitmen penuh untuk menjadikan investasi Anda berwujud bangunan yang tidak hanya kokoh dan fungsional, tetapi juga estetis dan bernilai tinggi untuk masa depan.
        </p>
      </section>

      {/* Bagian Layanan Unggulan */}
      <section className="rekanata-services-section">
        <h2 className="rekanata-section-heading">Layanan Unggulan Kami</h2>
        <p>Kami menawarkan spektrum layanan konstruksi yang komprehensif, dirancang untuk memenuhi setiap kebutuhan spesifik Anda dengan keahlian dan efisiensi:</p>
        <ul>
          <li>
            <strong>Desain & Bangun (Design & Build):</strong>
            <p>Solusi terintegrasi dari tahap konseptual hingga konstruksi akhir. Kami menangani seluruh proses perencanaan, perizinan, desain arsitektur, interior, struktur, hingga pelaksanaan pembangunan. Pendekatan ini menyederhanakan proyek Anda, menjamin efisiensi, dan meminimalkan risiko.</p>
          </li>
          <li>
            <strong>Konstruksi Bangunan Baru (Residential, Commercial, Institutional):</strong>
            <p>Mulai dari fondasi hingga serah terima kunci, kami membangun berbagai jenis bangunan seperti rumah tinggal, kantor, ruko, pabrik, gudang, hingga bangunan institusional seperti masjid. Fokus kami adalah pada kualitas superior, ketahanan struktur, dan penyelesaian yang presisi.</p>
          </li>
          <li>
            <strong>Renovasi & Remodel:</strong>
            <p>Kami mengubah dan meningkatkan fungsi serta estetika ruang yang sudah ada, baik itu rumah, kantor, atau fasilitas komersial. Layanan kami meliputi penataan ulang ruang, upgrade material, hingga penambahan struktur untuk menciptakan lingkungan yang lebih modern, fungsional, dan bernilai.</p>
          </li>
          <li>
            <strong>Desain Interior:</strong>
            <p>Menciptakan ruang dalam yang indah, nyaman, dan efisien. Tim desainer interior kami akan bekerja sama dengan Anda untuk mewujudkan visi estetika dan fungsionalitas ruang, memastikan setiap sudut mencerminkan karakter dan kebutuhan pengguna.</p>
          </li>
          <li>
            <strong>Master Plan & Pengembangan Lahan:</strong>
            <p>Menyediakan perencanaan komprehensif untuk pengembangan lahan berskala besar, mulai dari studi kelayakan, zonasi, hingga desain tata letak infrastruktur dan fasilitas. Layanan ini ideal untuk pengembangan kawasan perumahan, industri, atau komersial.</p>
          </li>
          <li>
            <strong>Lanskap & Pertamanan:</strong>
            <p>Merancang dan membangun area eksterior yang fungsional, estetis, dan berkelanjutan. Kami mengubah lahan kosong menjadi ruang hijau yang menenangkan, taman fungsional, atau area rekreasi yang indah, meningkatkan daya tarik visual dan nilai properti.</p>
          </li>
          <li>
            <strong>Konsultasi & Manajemen Proyek:</strong>
            <p>Dapatkan panduan ahli dari tim profesional kami di setiap tahapan proyek. Kami menyediakan manajemen proyek yang ketat untuk memastikan efisiensi, kepatuhan anggaran, kualitas, dan penyelesaian tepat waktu, meminimalkan potensi masalah.</p>
          </li>
        </ul>
      </section>

      {/* Bagian Mengapa Memilih Rekanata Konstruksi? */}
      <section className="rekanata-why-choose-us">
        <h2 className="rekanata-section-heading">Mengapa Memilih Rekanata Konstruksi?</h2>
        <div className="why-choose-points">
          <div className="point-item">
            <h3>Profesionalisme & Keahlian Tak Tertandingi</h3>
            <p>Tim kami terdiri dari arsitek, insinyur sipil, manajer proyek, dan tenaga konstruksi bersertifikasi yang sangat berpengalaman. Setiap anggota didedikasikan untuk menghadirkan solusi inovatif dan berkelas tinggi untuk setiap tantangan proyek.</p>
          </div>
          <div className="point-item">
            <h3>Kualitas & Standar Pengerjaan Unggul</h3>
            <p>Kami hanya menggunakan material premium yang teruji dan menerapkan standar pengerjaan tertinggi di setiap tahapan. Ini memastikan bangunan yang kami hasilkan tidak hanya indah secara estetika, tetapi juga kokoh, tahan lama, dan aman untuk jangka panjang.</p>
          </div>
          <div className="point-item">
            <h3>Amanah, Transparansi & Integritas Penuh</h3>
            <p>Kepercayaan adalah fondasi hubungan kami dengan klien. Kami berkomitmen pada transparansi total dalam setiap aspek proyek, dari detail anggaran, progres pekerjaan, hingga jadwal, memastikan Anda selalu terinformasi dan merasa aman.</p>
          </div>
          <div className="point-item">
            <h3>Manajemen Proyek Efisien & Tepat Waktu</h3>
            <p>Dengan perencanaan strategis dan eksekusi yang disiplin, kami menjamin penyelesaian proyek sesuai linimasa yang disepakati dan dalam batas anggaran, meminimalkan penundaan dan pembengkakan biaya, memastikan investasi Anda terlindungi.</p>
          </div>
          <div className="point-item">
            <h3>Mendukung Skema Pembayaran Cost and Fee</h3>
            <p>Untuk transparansi dan kontrol biaya yang optimal, kami menyediakan opsi skema pembayaran Cost and Fee. Klien dapat memantau setiap pengeluaran material dan jasa secara detail, ditambah dengan fee manajemen yang disepakati di awal, memberikan Anda visibilitas dan kepercayaan penuh.</p>
          </div>
          <div className="point-item">
            <h3>Solusi Kustom & Pendekatan Berpusat Klien</h3>
            <p>Setiap visi adalah unik. Kami mendengarkan secara mendalam kebutuhan dan preferensi Anda, kemudian merancang dan melaksanakan solusi konstruksi yang disesuaikan secara presisi untuk mewujudkan impian arsitektur Anda.</p>
          </div>
          <div className="point-item">
            <h3>Komitmen Keselamatan & Keberlanjutan Lingkungan</h3>
            <p>Keselamatan di lokasi kerja adalah prioritas mutlak, dengan penerapan standar K3 yang ketat. Kami juga berdedikasi pada praktik konstruksi yang bertanggung jawab dan ramah lingkungan, berkontribusi pada masa depan yang lebih baik.</p>
          </div>
          <div className="point-item">
            <h3>Dukungan Purna Jual & Garansi Terpercaya</h3>
            <p>Kemitraan kami berlanjut setelah serah terima proyek. Kami menyediakan layanan purna jual yang responsif dan garansi konstruksi untuk memastikan kepuasan jangka panjang serta ketenangan pikiran Anda.</p>
          </div>
        </div>
      </section>

      {/* Bagian Ajakan Bertindak (Call to Action) yang Dimodifikasi - Layout Mirip Gambar */}
      <section className="rekanata-cta-section-new-layout">
        <div className="cta-content-wrapper-new">
          {/* Bagian Kiri: Teks */}
          <div className="text-cta-section">
            <h2 className="cta-main-heading-new">
              Mulai Proyek Impian Anda Bersama Kami
            </h2>
            <p className="cta-paragraph-new">
              Jangan tunda lagi mewujudkan bangunan impian Anda. Rekanata Konstruksi siap menjadi mitra terpercaya Anda, menghadirkan inovasi, kualitas, dan transparansi dalam setiap pilar yang kami bangun.
            </p>
          </div>

          {/* Bagian Kanan: Video dan Tombol Konsultasi */}
          <div className="video-and-button-section">
            <div className="video-placeholder-new">
              <video
                ref={videoRef} // <--- Hubungkan ref ke elemen video
                width="100%"
                height="auto"
                controls
                muted // <--- Penting untuk autoplay di sebagian besar browser
              // autoPlay // Hapus autoplay di sini, kita akan mengontrolnya dengan JS
              // loop // Opsional: jika ingin video looping saat terlihat
              >
                <source src={MyRenderVideo} type="video/mp4" />
                Browser Anda tidak mendukung tag video.
              </video>
            </div>
            <div className="cta-buttons-group-new">
              <a href="https://wa.me/+6282110002640?text=Halo%20Rekanata%20Konstruksi%2C%20saya%20tertarik%20untuk%20konsultasi%20mengenai%20proyek%20saya." target="_blank" rel="noopener noreferrer" className="btn-contact-us-new">
                <i className="fab fa-whatsapp"></i> Konsultasi Sekarang
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RekanataContent;